import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from 'actions/chat/interactiveSurvey';
import ChatInteractiveSurveyAsk from 'components/chat/interactiveSurvey/Ask';
import { sortAdditionalDataList } from 'reducers/chat/interactiveSurvey';

const container = connect(
  state => ({
    willAnswerLabel: state.chat.main.clientConfiguration.interactiveSurvey.willAnswerLabel,
    wontAnswerLabel: state.chat.main.clientConfiguration.interactiveSurvey.wontAnswerLabel,
    willAnswer: state.chat.interactiveSurvey.willAnswer,
    nextAdditionalData: state.chat.interactiveSurvey.surveyInformation.surveyAdditionalDataLists.sort(sortAdditionalDataList)[0],
  }),
  dispatch => bindActionCreators(({
    onAccept: actions.willAnswer,
    onDecline: actions.wontAnswer,
  }), dispatch)
)(ChatInteractiveSurveyAsk);

export default container;



// WEBPACK FOOTER //
// ./containers/chat/interactiveSurvey/Ask.js